/**
 * @name Poisson.js
 * @description ヤコビ法によるポアソン方程式の解法
 */
import * as THREE from "three";
import face_vert from "./shader/face.vert";
import poisson_frag from "./shader/poisson.frag";

class Poisson {
    constructor(stage, props) {
        this.renderer = stage.renderer;

        this.scene = new THREE.Scene();
        this.camera = new THREE.Camera();
        
        this.props = props;

        this.uniforms = {
            boundarySpace: {
                value: this.props.boundarySpace
            },
            pressure: {
                value: this.props.dst_.texture
            },
            divergence: {
                value: this.props.src.texture
            },
            px: {
                value: this.props.cellScale
            }
        }

        this.output = this.props.dst;
        this.output0 = this.props.dst_;
        this.output1 = this.props.dst;

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.__createPlane();
    }

    /**
     * @name __createPlane
     */
    __createPlane() {
        const geo = new THREE.PlaneGeometry(2.0, 2.0);
        const mat = new THREE.RawShaderMaterial({
            vertexShader: face_vert,
            fragmentShader: poisson_frag,
            uniforms: this.uniforms
        });
        this.plane = new THREE.Mesh(geo, mat);
        this.scene.add(this.plane);
    }

    /**
     * @name __raf
     * @param {Object} iterations
     */
    __raf({ iterations }) {
        let p_in, p_out;

        for (var i = 0; i < iterations; i++) {
            if (i % 2 == 0) {
                p_in = this.output0;
                p_out = this.output1;
            } else {
                p_in = this.output1;
                p_out = this.output0;
            }

            this.uniforms.pressure.value = p_in.texture;
            this.output = p_out;

            this.renderer.setRenderTarget(this.output);
            this.renderer.render(this.scene, this.camera);
            this.renderer.setRenderTarget(null);
        }

        return p_out;
    }
}

export default Poisson;